import { Color } from "./Theme.color.model";

export enum ThemeEnum {
  DARK = "dark",
  LIGHT = "light",
}

export type ThemeType = ThemeEnum.DARK | ThemeEnum.LIGHT;

export interface Theme {
  "--icon-color": Color;
  "--icon-color-active": Color;
  "--background": Color;
  "--background-secondary": Color;
  "--text-main": Color;
  "--text-gray": Color;
  "--text-gray-lighter": Color;
  "--text-gray-lightest": Color;
  "--border-default": Color;
  "--border-thick": Color;
  "--layer-1": Color;
  "--layer-2": Color;
  "--layer-3": Color;
  "--layer-4": Color;
  "--button-default-bg": Color;
  "--button-ghost-text": Color;
  "--button-secondary-bg": Color;
  "--button-disable-bg": Color;
  "--button-default-hover-bg": Color;
  "--button-ghost-hover-text": Color;
  "--button-secondary-hover-bg": Color;
  "--button-disabled-text": Color;
  "--button-default-pressed-bg": Color;
  "--button-secondary-text": Color;
  "--button-default-text": Color;
  "--button-default-pressed-text": Color;
  "--soft-area": Color;
  "--soft-element": Color;
  "--highlighted": Color;
  "--soft-area-active": Color;
  "--table-hover": Color;
  "--helper-danger-900": Color;
  "--helper-danger-800": Color;
  "--helper-danger-300": Color;
  "--helper-danger-200": Color;
  "--helper-danger-100": Color;
  "--helper-danger-50": Color;
  "--helper-peace-900": Color;
  "--helper-peace-800": Color;
  "--helper-peace-300": Color;
  "--helper-peace-200": Color;
  "--helper-peace-100": Color;
  "--helper-peace-50": Color;
  "--helper-blue-900": Color;
  "--helper-blue-800": Color;
  "--helper-blue-300": Color;
  "--helper-blue-200": Color;
  "--helper-blue-100": Color;
  "--helper-blue-50": Color;
  "--helper-orange-900": Color;
  "--helper-orange-800": Color;
  "--helper-orange-300": Color;
  "--helper-orange-200": Color;
  "--helper-orange-100": Color;
  "--helper-orange-50": Color;
  "--helper-purple-900": Color;
  "--helper-purple-800": Color;
  "--helper-purple-300": Color;
  "--helper-purple-200": Color;
  "--helper-purple-100": Color;
  "--helper-purple-50": Color;
  "--helper-aqua-900": Color;
  "--helper-aqua-800": Color;
  "--helper-aqua-300": Color;
  "--helper-aqua-200": Color;
  "--helper-aqua-100": Color;
  "--helper-aqua-50": Color;
  "--helper-sky-900": Color;
  "--helper-sky-800": Color;
  "--helper-sky-300": Color;
  "--helper-sky-200": Color;
  "--helper-sky-100": Color;
  "--helper-sky-50": Color;
  "--helper-neutral-900": Color;
  "--helper-neutral-800": Color;
  "--helper-neutral-300": Color;
  "--helper-neutral-200": Color;
  "--helper-neutral-100": Color;
  "--helper-neutral-50": Color;
  "--overlay-high": Color;
  "--overlay-medium": Color;
  "--overlay-low": Color;
  "--button-white": Color;
  "--tabbar-active": Color;
}
